export const PRICE_FORMAT = /\B(?=(\d{3})+(?!\d))/g;
export const PRICE_PARSER = /[^0-9,-]/g;
export const PRICE_MAX = 10 ** 9;
